import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";

const useDarkMode = (startValue) => {
  const [value, setValue] = useState(startValue);

  useEffect(() => {
    if (value !== undefined) {
      window.localStorage.setItem("darkMode", value ? "true" : "false");
      document.body.classList.add(value ? "dark-mode" : "light-mode");
      document.body.classList.remove(value ? "light-mode" : "dark-mode");
    } else {
      setValue(window.localStorage.getItem("darkMode") === "true");
    }
  }, [value]);

  return {
    value,
    toggle: (e) => setValue(e.target.checked),
  };
};

const ThemeSwitch = ({ className }) => {
  const darkMode = useDarkMode();
  const intl = useIntl();

  return (
    <div className="theme-switch">
      <div
        className={`nj-switch nj-switch--alternate${
          className ? ` ${className}` : ``
        }`}
      >
        <label className="mb-0">
          <input
            type="checkbox"
            checked={darkMode.value || false}
            onChange={darkMode.toggle}
            aria-label={intl.formatMessage({ id: "switch-theme" })}
          />
          <span className="nj-switch__slider">
            <span className="nj-switch__slider-left px-0">
              <i className="nj-icon nj-icon-sun nj-icon--white"></i>
            </span>
            <span className="nj-switch__slider-right px-0">
              <i className="nj-icon nj-icon-nature nj-icon--white"></i>
            </span>
          </span>
        </label>
      </div>
    </div>
  );
};

export default ThemeSwitch;
